import script from "./Subscriptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&setup=true&lang=ts"

import "./Subscriptions.vue?vue&type=style&index=0&id=b7cbafec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7cbafec"]])

export default __exports__